import { patchRequest, putRequest } from "../httpMethods";

export const putSchoolProfile= (payload) =>
    patchRequest(`school/profile`, payload);

export const putAddress = (id, payload) =>
    putRequest(`v1/address/${id}`, payload);
